import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=9ba2f08a&scoped=true"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"
import style0 from "./Results.vue?vue&type=style&index=0&id=9ba2f08a&prod&lang=css"
import style1 from "./Results.vue?vue&type=style&index=1&id=9ba2f08a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba2f08a",
  null
  
)

export default component.exports